export default __webpack_public_path__ + "media/a3fb86dd7a5134ac45173adf6131c61d7c5ff2c3e01310ef941b5bd4747edc0b.svg";